import { useState, useEffect } from 'react';

const useDynamicColspan = () => {
  const [colspan, setColspan] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      // Adjust colspan based on window width
      if (window.innerWidth <= 767) {
        setColspan(2);
      } else {
        setColspan(3);
      }
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Initial setup
    handleResize();

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return colspan;
};

export default useDynamicColspan;
